import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

import LoadingScreen from '@/components/common/loadingScreen.vue';
import { onMounted, ref } from 'vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import { activeBonuseClaim, getActiveBonusInfo } from '@/api/activity';
import { useUserStore } from '@/stores/user';
import ActiveBonusView from '@/themes/themeOne/activeBonus/activeBonusView.vue';
import { ActiveBonusData } from './supportScript';
import ActiveBonusViewTwo from '@/themes/themeTwo/activeBonus/activeBonusView.vue';
import ActiveBonusViewThree from '@/themes/themeThree/activeBonus/activeBonusView.vue';
import { useThemeStore } from '@/stores/theme';


export default /*@__PURE__*/_defineComponent({
  __name: 'activeBonusView',
  setup(__props) {

const themeStore = useThemeStore()
const userStore = useUserStore()
const loadingRef = ref()
const isSuccess = ref(false)
const toastContent = ref('')
const statusRef = ref()
const yesterRewardAmount = ref(0)
const todayRewardAmount = ref(0)
const yesterBetAmount = ref(0)
const todayBetAmount = ref(0)
const activityIntro = ref([])
const activityConfig = ref<any>({})
const rewardList = ref([])
const flatIcon = ref('')

const dataSet = ref<ActiveBonusData>({
    yesterRewardAmount: 0,
    todayRewardAmount: 0,
    yesterBetAmount: 0,
    todayBetAmount: 0,
    activityIntro: [],
    activityConfig: {},
    rewardList: [],
    flatIcon: ''
})
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const getActivityInfo = () => {
    loadingRef.value.open()
    getActiveBonusInfo().then(res => {
        loadingRef.value.close()
        activityConfig.value = res.data
        yesterBetAmount.value = res.data?.yesterdayBet || 0
        yesterRewardAmount.value = res.data?.yesterdayCoin || 0
        todayBetAmount.value = res.data?.todayBet || 0
        todayRewardAmount.value = res.data?.todayCoin || 0
        activityConfig.value = JSON.parse(res.data?.activityVo?.activityConfig) || {}
        rewardList.value = activityConfig.value?.rewards || []
        activityIntro.value = JSON.parse(res.data?.activityVo?.activityIntro) || []
        flatIcon.value = res.data?.activityVo?.flatIcon || ''

        dataSet.value = {
            activityConfig: activityConfig.value,
            yesterBetAmount: yesterBetAmount.value,
            yesterRewardAmount: yesterRewardAmount.value,
            todayBetAmount: todayBetAmount.value,
            todayRewardAmount: todayRewardAmount.value,
            rewardList: rewardList.value,
            activityIntro: activityIntro.value,
            flatIcon: flatIcon.value
        }
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
        }
    })
}

const activeBonusClaim = () => {
    loadingRef.value.open()
    let data = {
        uid: userStore.id
    }
    activeBonuseClaim(data).then(res => {
        loadingRef.value.close()
        getActivityInfo()
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
        }
    })
}
onMounted(() => {
    getActivityInfo();
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(themeStore).themeIndex == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(ActiveBonusView, {
            "data-set": dataSet.value,
            onActiveBonusClaim: activeBonusClaim
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(ActiveBonusViewTwo, {
            "data-set": dataSet.value,
            onActiveBonusClaim: activeBonusClaim
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex == 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(ActiveBonusViewThree, {
            "data-set": dataSet.value,
            onActiveBonusClaim: activeBonusClaim
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"])
  ], 64))
}
}

})